import { FC } from 'react';
import { ProductionShift } from '../../../ProductionShift';
import { ProductionVolumeSectionProps } from './ProductionVolumeSection.types';
import { Container } from './ProductionVolumeSection.styles';
import { AllieText } from '../../../../../components/Text';
import { isMobile, numberFormatWithCommas } from '../../../../../common/utils';

export const ProductionVolumeSection: FC<ProductionVolumeSectionProps> = ({
  weeklyProduction,
  estimatedProduction,
  unit,
  labels,
  isEmpty,
}) => {
  const progress = weeklyProduction / estimatedProduction;

  const getValue = (value: number) =>
    `${numberFormatWithCommas(Number(value.toFixed(2)))} ${labels.units[unit] || unit}`;

  return (
    <Container>
      <AllieText type="body1" weight={500}>
        {labels.title}
      </AllieText>
      <ProductionShift
        productionLabel={labels.weeklyLabel}
        productionValue={isEmpty ? labels.withoutData : getValue(weeklyProduction)}
        estimatedLabel={labels.estimatedLabel}
        estimatedValue={isEmpty ? labels.withoutData : getValue(estimatedProduction)}
        progress={progress}
        redThreshold={50}
        greenThreshold={75}
        style={{ borderColor: 'var(--allie-color-neutral-20)' }}
        fullWidth
        showIcon={!isMobile}
      />
    </Container>
  );
};
